import script from "./InformationEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationEdit.vue?vue&type=script&setup=true&lang=js"

import "./InformationEdit.vue?vue&type=style&index=0&id=5b72c59e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b72c59e"]])

export default __exports__